import { render, staticRenderFns } from "./ThgRegistrationUploadCard.vue?vue&type=template&id=0f01a1a6&"
import script from "./ThgRegistrationUploadCard.vue?vue&type=script&lang=ts&"
export * from "./ThgRegistrationUploadCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports